import React from 'react';
import { useLazyQuery } from '@apollo/client';
import { REST_GRAPHQL_CLIENTNAME } from '@famly/stat_apollo-client';
/**
 * Apollo's `useLazyQuery`, routed at the REST GraphQL client.
 *
 * The client name is added to the context of the execute function rather than to the hook's
 * options, because that is the only place a lazy query reads it from: the hook options describe
 * the query, and `variables` and `context` belong to one execution of it.
 *
 * A caller's own context is merged in and wins on every key but `clientName`, which is what
 * routes the operation at the REST link.
 */
export function useRestLazyQuery(query, options) {
    const [execute, result] = useLazyQuery(query, options);
    // Apollo hands out a stable execute function, and callers depend on that: several list it in
    // a `useEffect` dependency array, where a new identity per render would re-run the effect in
    // a loop. The React Compiler would hold this one stable in the app bundle, but it does not
    // run under Jest, so the memoisation has to be written out to survive both.
    const executeAgainstRestClient = React.useCallback(executeOptions => execute({
        ...executeOptions,
        context: { ...executeOptions === null || executeOptions === void 0 ? void 0 : executeOptions.context, clientName: REST_GRAPHQL_CLIENTNAME },
    }), [execute]);
    return [executeAgainstRestClient, result];
}
